import { render, staticRenderFns } from "./bindOldAcct.vue?vue&type=template&id=1f02dbda"
import script from "./bindOldAcct.vue?vue&type=script&lang=js"
export * from "./bindOldAcct.vue?vue&type=script&lang=js"
import style0 from "./bindOldAcct.vue?vue&type=style&index=0&id=1f02dbda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports